import React, { useEffect, useContext } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { UserContext } from '~contexts/user';
import { getIntersection, hasWishOrOperations } from '~helpers/common';
import { useIsFirstRender } from '~hooks/common';
import IntakeActions from '~redux/intake';

import FullLoader from '~components/loader/full-loader';
import AccessDenied from '~containers/access-denied';

const ProtectedRoute = ({ path, forScope = [], children, ...rest }) => {
  const location = useLocation();
  const isFirstRender = useIsFirstRender();

  const { user, isLoading: isFetchingUser } = useContext(UserContext);
  const { isLoading: isLoadingAuth0 } = useAuth0();
  const { accountType } = user;

  const status =
    isLoadingAuth0 || isFetchingUser || (isFirstRender && !accountType)
      ? 'LOADING'
      : !accountType || getIntersection(forScope, [accountType]).length <= 0
      ? 'ACCESS_DENIED'
      : !hasWishOrOperations(user)
      ? 'REDIRECT_TO_INTAKE'
      : 'AUTHORIZED';

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Route path={path} location={location} {...rest}>
      {status === 'AUTHORIZED' ? (
        children
      ) : status === 'ERROR' || status === 'ACCESS_DENIED' ? (
        <AccessDenied />
      ) : status === 'REDIRECT_TO_INTAKE' ? (
        <Redirect
          to={{
            pathname: accountType === 'client' ? '/intake/client' : 'intake/worker',
          }}
        />
      ) : (
        <FullLoader />
      )}
    </Route>
  );
};

const RedirectWithReferrer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const referrer = encodeURIComponent(location.pathname + location.search);
    dispatch(IntakeActions.setReferrer(referrer));
  }, []);

  return <FullLoader />;
}

export default withAuthenticationRequired(ProtectedRoute, {
  onRedirecting: () => <RedirectWithReferrer />
});
